import HeaderPortal from "components/portal/header-portal";
import { FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Form } from "react-crud-form";
import { Input } from "ui/components/input";
import React from "react";
import SelectStatus from "components/select/status"
import { EntitySchema } from "./schema";
import { Button } from "ui/index";
import { useParams } from "react-router-dom";
import SelectName from "components/select/name";
import { useEntityForm } from "./useEntityForm";

const EntityForm = () => {

    const { entityId } = useParams();

    const {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    } = useEntityForm({ entityId });

    return (
        <div className="flex-1 max-w-md p-4">
            <Form
                form={form}
                create={handleCreate}
                read={handleRead}
                update={handleUpdate}
                itemId={entityId || "+"}
                schema={EntitySchema}
            >
                {({
                    isCreating,
                    createItem,
                    isNewItem,
                    isUpdating,
                    updateItem,
                    isDirty,
                }) => {
                    return (
                        <div className="space-y-6">

                            {/* name */}
                            <FormField
                                control={form.control}
                                name="name"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Name</FormLabel>
                                            <Input {...field} />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Organisation */}
                            <FormField
                                control={form.control}
                                name="organisation"
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel required={requiredFields.includes(field.name)}>Organisation</FormLabel>
                                        <SelectName
                                            collection="organisations"
                                            fetchItems={true}
                                            onValueChange={val => field.onChange(val)}
                                            {...field}
                                        />
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />

                            {/* Status */}
                            <FormField
                                control={form.control}
                                name="status"
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel required={requiredFields.includes(field.name)}>Status</FormLabel>
                                        <SelectStatus
                                            collection="legal_entities"
                                            onValueChange={val => field.onChange(val)}
                                            {...field}
                                        />
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />

                            {/* Portal buttons similar to TimesheetLog */}
                            <HeaderPortal>
                                {isNewItem ? (
                                    <Button
                                        variant="default"
                                        isLoading={isCreating}
                                        onClick={createItem}
                                    >
                                        Save
                                    </Button>
                                ) : (
                                    <Button
                                        variant="default"
                                        isLoading={isUpdating}
                                        disabled={!isDirty}
                                        onClick={updateItem}
                                    >
                                        Save
                                    </Button>
                                )}
                            </HeaderPortal>
                        </div>
                    );
                }}
            </Form>
        </div>
    );
};

export default EntityForm;
